import React from "react";
import { Box, Typography } from "@mui/material";

const SectionCard = ({ title, children }) => {
  return (
    <Box
      sx={{
        mt: 2,
        p: 2,
        border: "1px solid rgba(0,0,0,0.12)",
        borderRadius: 1,
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2 }}>
        {title}
      </Typography>
      {children}
    </Box>
  );
};

export default SectionCard;
